import { render, staticRenderFns } from "./birthday.vue?vue&type=template&id=7a0f0968&scoped=true&lang=pug&"
import script from "./birthday.vue?vue&type=script&lang=js&"
export * from "./birthday.vue?vue&type=script&lang=js&"
import style0 from "./birthday.vue?vue&type=style&index=0&id=7a0f0968&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a0f0968",
  null
  
)

export default component.exports